/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Deep_MatchInputs */

const en_nav_deep_match = /** @type {(inputs: Nav_Deep_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const de_nav_deep_match = /** @type {(inputs: Nav_Deep_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiefenanalyse`)
};

const fr_nav_deep_match = /** @type {(inputs: Nav_Deep_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const es_nav_deep_match = /** @type {(inputs: Nav_Deep_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const it_nav_deep_match = /** @type {(inputs: Nav_Deep_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const nl_nav_deep_match = /** @type {(inputs: Nav_Deep_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const pl_nav_deep_match = /** @type {(inputs: Nav_Deep_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const fi_nav_deep_match = /** @type {(inputs: Nav_Deep_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const da_nav_deep_match = /** @type {(inputs: Nav_Deep_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const sv_nav_deep_match = /** @type {(inputs: Nav_Deep_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

/**
* | output |
* | --- |
* | "Deep Match" |
*
* @param {Nav_Deep_MatchInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_deep_match = /** @type {((inputs?: Nav_Deep_MatchInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Deep_MatchInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_deep_match(inputs)
	if (locale === "fr") return fr_nav_deep_match(inputs)
	if (locale === "es") return es_nav_deep_match(inputs)
	if (locale === "it") return it_nav_deep_match(inputs)
	if (locale === "nl") return nl_nav_deep_match(inputs)
	if (locale === "pl") return pl_nav_deep_match(inputs)
	if (locale === "fi") return fi_nav_deep_match(inputs)
	if (locale === "da") return da_nav_deep_match(inputs)
	if (locale === "sv") return sv_nav_deep_match(inputs)
	return en_nav_deep_match(inputs)
});